import { AbstractParser } from "../../parser";
import { BeneficiaryKey } from "src/app/ui/models/domains/pbm/Benefit/beneficiary-key";

export class SaveBenficiaryParser extends AbstractParser<string> {
  parse(payload: any) {
    if (payload.error) {
      return payload.error.Data.ErrorMessage;
    } else if (payload.Value) {
      const beneficiaryKey = new BeneficiaryKey();
      beneficiaryKey.setValue(payload.Value);
      return beneficiaryKey;
    }
  }
}
